module.exports = __webpack_public_path__ + "static/media/main11.008222c3.jpeg";